import React from 'react';
import { getRum } from '../rum';

interface Props {
	children: React.ReactNode;
}

interface State {
	hasError: boolean;
	error?: Error;
}

class RumErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		const rum = getRum();
		if (rum) {
			rum.recordError(error);
		}
		console.error('[RumErrorBoundary]', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: '2rem', textAlign: 'center' }}>
					<h1>Unexpected Application Error!</h1>
					<p>{this.state.error?.message}</p>
				</div>
			);
		}
		return this.props.children;
	}
}

export default RumErrorBoundary;
